import $ from 'jquery';
import ProductDetails from '../snippets/ProductDetails';
import ProductHighlights from '../snippets/ProductHighlights';
import ProductZoom from '../snippets/ProductZoom';
import ProductMenu from '../snippets/ProductMenu';

export default class StaticProduct {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);

    // Init product zooms
    this.productZooms = [];
    this.$el.find('[data-product-image]').each((index, el) => {
      this.productZooms.push(new ProductZoom($(el)));
    });

    // Product details
    this.productDetails = new ProductDetails(this.$el, section);

    // Product menu
    if (!this.section.data.form_is_inline) {
      this.productMenu = new ProductMenu(this.$el, this.section.data, this.section.postMessage);
    }

    // Related products
    const $related = $('[data-product-highlights]', this.$el);
    if ($related.length) {
      this.related = new ProductHighlights($related, this.section.postMessage);
    }
  }

  onSectionMessage(name, data) {
    if (name === 'product:change-variant') {
      this.productDetails.selectVariantImage(data.variant);
    }
  }

  onSectionUnload() {
    if (this.related) this.related.unload();
    if (this.productMenu) this.productMenu.unload();
    this.productDetails.unload();
    this.productZooms.forEach(zoom => zoom.unload());
  }
}
